import React, { useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";

import Time from "../components/time";
import { useNavigate, Link } from "react-router-dom"; 
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddDieselrate = () => {
  useAuthRedirect();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
  fld_rate: "",
  fld_date: new Date().toISOString().split("T")[0], // today's date
});

    const canEntry = hasPermission("Vehicle Diesel Rate", "entry");

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
          Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
      const response = await axios.post(
        "https://rfs2.infraconsoft.net.in/api/add_dieselrate_api",
        formData
      );

     Swal.fire({
               icon: "success",
               title: "Inserted!",
               text: "Diesel Rate inserted successfully.",
             });
      
      // Reset the form after submission
      setFormData({ fld_rate: "", fld_date: "" });

    
      navigate("/vehicle_dieselrate_listing");

    } catch (error) {
      console.error("Error inserting details:", error);
      Swal.fire({
                icon: "error",
                title: "Insert Failed",
                text: "Plese Try Again",
              });
    }
  };

    if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Add New Diesel Rate</h2>
          <Link to='/vehicle_dieselrate_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
       <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Diesel Rate:</label>
                <input
                  type="text"
                  name="fld_rate"
                  value={formData.fld_rate}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Date:</label>
<input
  type="date"
  name="fld_date"
  value={new Date().toISOString().split("T")[0]} 
  readOnly
/>

              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddDieselrate;
